// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2MvDB","clinicsSelect":"styles_clinicsSelect__2KIf3"};